"use client";
import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useColorScheme } from "@mui/material/styles";
import { useT } from "@/i18n/useT";

export default function ModeSwitch() {
  const { mode, setMode } = useColorScheme();
  const t = useT("ui.theme");
  if (!mode) {
    return null;
  }
  return (
    <Box
      sx={{
        fontSize: 16,
        width: 80,
        minWidth: 80,
        ".MuiSelect-select": {
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 1,
        },
      }}
    >
      <FormControl>
        <InputLabel id="mode-select-label">{t("label")}</InputLabel>
        <Select
          labelId="mode-select-label"
          id="mode-select"
          value={mode}
          onChange={(event) => setMode(event.target.value as typeof mode)}
          label={t("label")}
          MenuProps={{
            sx: {
              zIndex: 1302, // Ensure dropdown appears above header
            },
          }}
        >
          <MenuItem value="system">
            {t("system", { default: "System" })}
          </MenuItem>
          <MenuItem value="light">{t("light", { default: "Light" })}</MenuItem>
          <MenuItem value="dark">{t("dark", { default: "Dark" })}</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}
